import Vue from 'vue';
export const EventBus = new Vue();

export default {
  data() {
    return {
      isChatActive: false,
    };
  },

  mounted() {
    // When chat starts
    EventBus.$on('chat-started', () => {
      this.isChatActive = true;
    });

    // When chat ends
    EventBus.$on('chat-ended', () => {
      this.isChatActive = false;
    });
  },

  beforeDestroy() {
    EventBus.$off('chat-started');
    EventBus.$off('chat-ended');
  },
};
